import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';

@Injectable({
    providedIn: 'root'
})
export class RequireAuthenticatedUserGuard implements CanActivate {
    constructor(private oidcService: OpenIdConnectService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.oidcService.userAvailable) {
            return true;
        }

        // Set path to redirect to after signin
        localStorage.removeItem(this.oidcService.redirectKey);
        localStorage.setItem(this.oidcService.redirectKey, state.url);

        this.oidcService.triggerSignIn(window.location.pathname);

        return false;
    }
}
